import type { SubPedido } from '../db/tipos'

// Quais status de sub-pedido contam como VENDA para efeito de meta.
//
// ⚠ Uma lista so, importada pelos dois calculos (metasDados.ts e historico.ts).
// Ate 2026-08-05 cada arquivo tinha a sua copia, e foi assim que 'entregue'
// ficou de fora dos dois sem ninguem notar.
//
// ⭐ 'entregue' entra AO LADO de faturado e pago, nao no lugar. Ele entrou no
// Ciclo 2 (spec 2026-07-29) entre faturado e pago: a mercadoria chegou e falta
// so o cliente pagar. Sem ele aqui, confirmar a entrega FAZIA O PEDIDO SUMIR do
// progresso da meta -- a barra do Painel andava para tras, e a media do
// historico (que vira a meta sugerida) saia menor do que a vendedora vendeu.
//
// O modulo de comissao ja tinha esse cuidado, com o motivo escrito em
// lancamentos.ts:84-95: "sem isso a comissao ja liberada no faturamento
// voltaria para prevista quando ela confirmasse a entrega -- dinheiro andando
// para tras sozinho". As metas nao tinham.
//
// Fora da lista, e por que: 'rascunho' (ainda nao fechou) e 'cancelado' (a
// venda caiu; conta-la inflaria a meta do mes seguinte em cima de dinheiro que
// nao entrou).
export const STATUS_VENDA: SubPedido['status'][] = [
  'fechado',
  'enviado',
  'faturado',
  'entregue',
  'pago',
]
